import Button from './Button';
import { useTranslation } from '../hooks/useTranslation';
import { Link } from 'react-router-dom';

const Cta = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 lg:px-8 bg-teal-500">
      <div className="container mx-auto max-w-6xl text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8">
          {t('ctaTitle')}
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/access">
            <Button size="lg" variant="ghost" className="bg-white">
              {t('startFreeTrial')}
            </Button>
          </Link>
          <a
            href="https://cal.com/appointdoc/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button size="lg" variant="ghost" className="bg-white">
              {t('scheduleDemo')}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;
